import { useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, X } from "lucide-react";

export default function AiRecommend({ caseId }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rec, setRec] = useState(null);
  const [err, setErr] = useState("");

  const run = async () => {
    setOpen(true); setLoading(true); setErr(""); setRec(null);
    try { const { data } = await api.post(`/cases/${caseId}/recommend`); setRec(data.recommendation); }
    catch (e) { setErr(e.response?.data?.detail?.toString() || e.message); }
    finally { setLoading(false); }
  };

  return (
    <>
      <button data-testid="ai-recommend-btn" onClick={run}
        className="border border-[#0033A0] text-[#0033A0] px-4 py-2 text-xs flex items-center gap-2 hover:bg-[#0033A0] hover:text-white">
        <Sparkles size={14} /> AI recommend
      </button>
      {open && (
        <div className="fixed inset-0 bg-slate-900/60 z-50 flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-xl border border-slate-300 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <div><div className="overline">Claude Sonnet 4.6</div><h3 className="font-heading font-extrabold text-xl">AI recommendation</h3></div>
              <button onClick={() => setOpen(false)}><X /></button>
            </div>
            <div className="p-6 text-sm space-y-4">
              {loading && <div className="text-slate-500 font-mono">Analysing case…</div>}
              {err && <div className="border border-red-300 bg-red-50 text-red-700 px-3 py-2">{err}</div>}
              {rec?.next_actions && (
                <div>
                  <div className="overline mb-2">Next actions</div>
                  <ol className="list-decimal ml-5 space-y-1">
                    {rec.next_actions.map((a, i) => <li key={i}>{a}</li>)}
                  </ol>
                </div>
              )}
              {rec?.suggested_partners?.length > 0 && (
                <div>
                  <div className="overline mb-2">Suggested partners</div>
                  <ul className="space-y-2">
                    {rec.suggested_partners.map((p, i) => (
                      <li key={i} className="border border-slate-200 p-3">
                        <div className="font-semibold">{p.name}</div>
                        <div className="text-xs text-slate-600">{p.why}</div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {rec?.risk_notes && <div className="border-l-2 border-[#F97316] pl-3 text-slate-700"><div className="overline mb-1">Risk notes</div>{rec.risk_notes}</div>}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
